// @ts-nocheck
// 导入 抽取的 请求对象
import ajaxRequest from '@/utils/request';
import { getToken } from '../utils/token';

const reFix = 'lognet';

// 获取操作日志列表
export function getDoLog(data) {
  return ajaxRequest({
    url: reFix + '/DoLog/Page',
    data,
    method: 'POST',
    headers: {
      houseId: JSON.parse(getToken('userInfo')).houseId,
    },
    // 跨域 是否携带 cookie
    withCredentials: true,
  });
}
// 获取操作日志详情
export function getDoLogDetailApi(params) {
  return ajaxRequest({
    url: reFix + '/DoLog/' + params,
    headers: {
      houseId: JSON.parse(getToken('userInfo')).houseId,
    },
    // 跨域 是否携带 cookie
    withCredentials: true,
  });
}
// 导出操作日志
export function getCustSerApi(params) {
  return ajaxRequest({
    url: reFix + '/CustSer',
    params,
    headers: {
      houseId: JSON.parse(getToken('userInfo')).houseId,
    },
    // 跨域 是否携带 cookie
    withCredentials: true,
  });
}
// 获取菜单模块对照表
export function getSysMenuApi(params) {
  return ajaxRequest({
    url: reFix + '/DoLog/SysMenu',
    params,
    headers: {
      houseId: JSON.parse(getToken('userInfo')).houseId,
    },
    // 跨域 是否携带 cookie
    withCredentials: true,
  });
}

// 获取登录对照表
export function getSysLoginApi(params) {
  return ajaxRequest({
    url: reFix + '/LoginLog/SysMenu',
    params,
    headers: {
      houseId: JSON.parse(getToken('userInfo')).houseId,
    },
    // 跨域 是否携带 cookie
    withCredentials: true,
  });
}
// 获取操作类型对照表
export function getSysOperationApi(params) {
  return ajaxRequest({
    url: reFix + '/DoLog/SysOperation',
    params,
    headers: {
      houseId: JSON.parse(getToken('userInfo')).houseId,
    },
    // 跨域 是否携带 cookie
    withCredentials: true,
  });
}
// 获取登录日志的列表
export function getLoginLog(data) {
  return ajaxRequest({
    url: reFix + '/LoginLog/Page',
    data,
    method: 'POST',
    headers: {
      houseId: JSON.parse(getToken('userInfo')).houseId,
    },
    // 跨域 是否携带 cookie
    withCredentials: true,
  });
}
